<ng-container *transloco="let t; read:'permit.signature'">
    <div class="modal">
        <div class="modal__content">
            <div class="modal__content__heading">
                {{ t("signature") }} <span class="modal__content__heading__roles" [innerHtml]="formattedRoles"></span>
            </div>

            <signature-pad *ngIf="signaturePadOptions" class="modal__content__signature" #signature [options]="signaturePadOptions"
                           (drawStart)="drawStart($event)" (drawEnd)="drawComplete($event)"></signature-pad>

            <div class="modal__content__details">
                <div class="modal__content__details__name-and-clear">
                    <div class="modal__content__details__name-and-clear__person">
                        <div class="modal__content__details__name-and-clear__person__name">
                            {{ data.person.firstName }} {{ data.person.lastName }}
                        </div>
                    </div>
                    <button class="modal__content__details__name-and-clear__clear-button" (click)="clear()">{{ t("clear") }}</button>
                </div>

                <div class="modal__content__details__agreement" *ngIf="!agrementAcceptedBefore && !data.isDemo">
                    <ha-checkbox (click)="openAgreement($event)" [(ngModel)]="agreementAccepted" [ngModelOptions]="{standalone: true}"
                                 [label]="t('agreementAccepted')">
                    </ha-checkbox>
                </div>
            </div>
            <div class="modal__content__details" *ngIf="data.person.concept === 2 && data.person.personalNumber === null && data.person.hasForeignPersonalNumber === false">
                <div class="modal__content__title">{{t("missingPersonalNumber")}}</div>
                <div class="modal__content__info-message">{{t("addressPersonalNumber")}}</div>
                <div class="modal__form__container">
                    <ha-input class="modal__form__field" type="personalNumber" [(ngModel)]="personalNumber" [label]="t('personalNumber')" (input)="personalNumberOnChange()"></ha-input>
                    <ha-checkbox class="modal__content--checkbox" [(ngModel)]="hasForeignPersonalNumber" [label]="t('noSwedishPnr')" (click)="hasForeginPersonalNumberClick()"></ha-checkbox>
                    <div *ngIf="(!isPersonalNumberValid)" class="modal__content__error-message">{{ t("invalidPnr") }}</div>
                </div>
            </div>
        </div>
        <div class="modal__actions">
            <button class="modal__actions__close" type="button" (click)="closeModal()">{{ t("cancel") }}</button>
            <button class="modal__actions__save" [class.modal__actions__save--disabled]="!isValid" type="button" (click)="save()">{{ t('save') }}</button>
        </div>
    </div>
</ng-container>
